module.exports = __webpack_public_path__ + "static/media/tt.12c225a0.svg";